import angular from 'angular';
import { MicroFrontendService } from 'modules/shared/MicroFrontendService';
import { blipSupportScriptSource } from 'app.constants';
import BlipSupportView from './BlipSupportView.html';
import { BlipSupportController } from './BlipSupportController';
import { BlipSupportFeatures } from './BlipSupportFeatures';
import { applicationListStateName } from 'modules/application/list';
import { defaultClusterName } from '../../app.constants';
export const blipSupportStateName = 'auth.blipSupport';
export default angular
    .module('blipSupport', ['ui.router'])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider
            .state(blipSupportStateName, {
            url: '/blip-support',
            controller: BlipSupportController,
            controllerAs: '$ctrl',
            onEnter: () => {
                return MicroFrontendService.addSource(blipSupportScriptSource);
            },
            template: BlipSupportView,
            resolve: {
                authorization: fetchBlipSupportPermission,
            },
        });
    }])
    .name;
const fetchBlipSupportPermission = ['$state', 'InitializeUserService', 'AccountService2', async function ($state, InitializeUserService, AccountService2) {
        await AccountService2.waitForInitialization();
        await InitializeUserService.initFeatureToggle();
        const isBlipSupportEnabled = await BlipSupportFeatures.isBlipSupportEnabled();
        const clusterName = defaultClusterName.toLowerCase();
        const isEnabled = isBlipSupportEnabled[clusterName] || false;
        if (!isEnabled) {
            $state.go(applicationListStateName);
        }
    }];
